import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../services/battery-monitoring-api/types/battery-monitoring-api';
import { type SelectedChartSegment } from '@/app/config/chart-segments';

interface UseOverviewChartVehiclesProperties {
  baseFilteredVehicles?: VehicleCycledEnergyRecord[];
  selectedStateOfHealthSegment: SelectedChartSegment | null;
  selectedCycledEnergySegment: SelectedChartSegment | null;
}

interface OverviewChartVehicles {
  stateOfHealthChartVehicles?: VehicleCycledEnergyRecord[];
  cycledPerKilometerChartVehicles?: VehicleCycledEnergyRecord[];
}

const useOverviewChartVehicles = ({
  baseFilteredVehicles,
  selectedStateOfHealthSegment,
  selectedCycledEnergySegment,
}: UseOverviewChartVehiclesProperties): OverviewChartVehicles => {
  return useMemo(() => {
    if (!baseFilteredVehicles) {
      return {};
    }

    return {
      stateOfHealthChartVehicles: selectedCycledEnergySegment
        ? baseFilteredVehicles.filter((vehicle) => selectedCycledEnergySegment.filterVehicle({ vehicle }))
        : baseFilteredVehicles,
      cycledPerKilometerChartVehicles: selectedStateOfHealthSegment
        ? baseFilteredVehicles.filter((vehicle) => selectedStateOfHealthSegment.filterVehicle({ vehicle }))
        : baseFilteredVehicles,
    };
  }, [baseFilteredVehicles, selectedStateOfHealthSegment, selectedCycledEnergySegment]);
};

export default useOverviewChartVehicles;
